// @todo Remove when dependency for redux / saga / recompose has been deprecated

import { compose } from 'recompose'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import RemoteComplianceShipments from './components/table'
import { exportCSV } from '../../../common/actions'

const mapDispatchToProps = (dispatch) => bindActionCreators(
  { shipmentsExportCSV: exportCSV },
  dispatch
)

const mapStateToProps = (state) => ({
  companyId: state.account.company._id,
  hasPosterCheck: state.account.company.posterCheck.pcEnabled,
  shipments: state.compliance.shipments
})

const RemoteComplianceShipmentsComponent = compose(connect(
  mapStateToProps,
  mapDispatchToProps
))(RemoteComplianceShipments)

export default RemoteComplianceShipmentsComponent
